module.exports = __webpack_public_path__ + "img/ducky_icon.47233fab.jpg";